<template>
  <div class="header">
    <div class="logo">
      <svg width="68" height="90" xmlns="http://www.w3.org/2000/svg"><path d="M68 21.904V23H45V0h1.096c1.15 0 2.246.45 3.055 1.258l17.591 17.61A4.299 4.299 0 0 1 68 21.903zm-24.083 6.221H68v57.656C68 88.12 66.105 90 63.75 90H4.25C1.895 90 0 88.12 0 85.781V4.22C0 1.88 1.895 0 4.25 0h35.417v23.906c0 2.32 1.912 4.219 4.25 4.219zM33.392 47.26L16.945 63.706l-.934 8.345a1.76 1.76 0 0 0 1.939 1.939l8.344-.935L42.74 56.608a.878.878 0 0 0 0-1.246l-8.102-8.102a.878.878 0 0 0-1.246 0zm19.524-4.527l-4.649-4.649a3.7 3.7 0 0 0-5.234 0l-4.758 4.759a.928.928 0 0 0 0 1.317l8.565 8.565a.928.928 0 0 0 1.317 0l4.759-4.758a3.7 3.7 0 0 0 0-5.234z" fill="#FFF" fill-rule="evenodd"/></svg>
    </div>
    <h1 class="title">Berufswahltest</h1>
    <h2 class="claim">Entdecke deine beruflichen Interessen</h2>
  </div>
</template>

<script>
export default {
  name: 'Header',
  computed: {},
}
</script>

<style scoped>
.header {
  margin: 0 15px 40px 15px;
  text-align: center;
  color: white;
}

.logo svg {
  margin: 0 auto 25px auto;
  display: block;
}

.title,
.claim {
  margin: 0;
}

.title {
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  font-size: 2.25rem;
}

.claim {
  font-weight: 300;
  font-size: 1.15rem;
}
</style>
